import { EasmScanConfigurationSchedulerController } from '../controller/EasmScanConfigurationSchedulerController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';

export class EasmScanConfigurationSchedulerWebComponent extends BaseWebComponentElement {
  public controller: EasmScanConfigurationSchedulerController | null;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: EasmScanConfigurationSchedulerController,
    });
  }
}
